import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import React, { useEffect } from 'react';
import { FormFieldProps } from 'lib/forms/FormFieldProps';
import { Field, FormikValues, useFormikContext } from 'formik';
import { getValueProviderValue } from 'lib/forms/FormFieldUtils';

export type HiddenProps = Feature.EnterpriseWeb.Enterprise.Forms.Fields.Hidden & FormFieldProps;

export const getInitialValue = (
  props: HiddenProps,
  additionalDetails?: Record<string, unknown> | undefined
) => {
  const valueProvider = getValueProviderValue(props, additionalDetails);
  if (valueProvider) {
    return valueProvider;
  } else if (props?.fields?.defaultValue) {
    return props?.fields?.defaultValue?.value || '';
  }
};

const Hidden = (props: HiddenProps): JSX.Element => {
  const { setFieldValue } = useFormikContext<FormikValues>();
  const fieldName = props?.fields?.fieldName?.value || props.id;

  const cookieProvider = props.fields?.valueProviders?.find(
    (provider: { templateId: string }) =>
      provider.templateId === 'b185f266-9182-4433-ae00-cbc6ae49dd1f'
  );

  useEffect(() => {
    if (!cookieProvider) {
      return;
    }

    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      const currentValue = getValueProviderValue(props);
      if (currentValue) {
        setFieldValue(fieldName, currentValue);
        clearInterval(interval);
      }
      if (attempts >= 5) {
        clearInterval(interval);
      }
    }, 1000); // Check for the cookie value and update the form field if it changes

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative mb-s" data-te-input-wrapper-init>
      <Field id={props.id} name={fieldName} type="hidden" />
    </div>
  );
};

export default Hidden;
